import { Link } from "react-router-dom";
import Reveal from "@/components/site/Reveal";
import { BRAND } from "@/lib/constants";
import { ArrowRight } from "lucide-react";

export default function PageHero({ overline, title, subtitle, image, imageAlt = "" }) {
  return (
    <section className="relative pt-28 md:pt-32" data-testid="page-hero">
      <div className="relative h-[60vh] min-h-[420px] w-full overflow-hidden">
        <img
          src={image}
          alt={imageAlt}
          width="1650"
          height="928"
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover animate-slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/65" />
        <div className="absolute inset-0 flex items-end pb-12 md:pb-16">
          <div className="mx-auto max-w-[1400px] w-full px-6 lg:px-10">
            <div className="text-white/85 text-[11px] tracking-overline uppercase animate-fade-up">{overline}</div>
            <h1 className="font-serif text-white text-5xl md:text-7xl font-light leading-[0.98] tracking-tight max-w-4xl mt-5 animate-fade-up delay-1">{title}</h1>
            {subtitle && <p className="mt-6 text-white/80 max-w-xl font-light text-lg leading-relaxed animate-fade-up delay-2">{subtitle}</p>}
            <div className="mt-10 flex gap-4 animate-fade-up delay-3">
              <a href={BRAND.calendly} target="_blank" rel="noreferrer" data-testid="page-hero-book-btn" className="inline-flex items-center gap-2 px-7 py-4 bg-white text-black text-[12px] tracking-overline uppercase hover:bg-white/90 transition">Book Free Consultation <ArrowRight size={14}/></a>
              <Link to="/contact" data-testid="page-hero-contact-btn" className="inline-flex items-center gap-2 px-7 py-4 border border-white/60 text-white text-[12px] tracking-overline uppercase hover:bg-white hover:text-black transition">Contact Us</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
